import React, { useState } from "react";
import { AddToCompare, RemoveFromCompare } from "redux/actions/globalAction";
import { connect } from "react-redux";
import TyreComparisonModal from "./TyreComparisonModal";

const TyresListing = ({ AddToCompare, RemoveFromCompare }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };
  const handleComparison = () => {
    setShowModal(!showModal);
  };
  const handleCompare = (e, index) => {
    if (e.target.checked == true) {
      AddToCompare(index);
    } else {
      RemoveFromCompare(index);
    }
  };
  return (
    <>
      <TyreComparisonModal showModal={showModal} handleClose={handleClose} />
      <div class="pl-list-outer mt-4 d-none">
        <button onClick={() => handleComparison()} class="view-comparison-btn">
          View Comparison (2)
        </button>
        <div class="pl-list-header">
          <div class="pl-list-header-lf">
            <h2>Tyres</h2>
            <p>29 tyre(s) found for Suzuki Swift</p>
          </div>
          <div class="pl-list-header-rt">
            <button>Looking for other Brands?</button>
            <button>Want Custom Size Tyre?</button>
          </div>
        </div>
        <div class="pl-list-scoller">
          {[null, null, null].map((item, index) => {
            return (
              <div class="listing-container-pl srolled-list-pl">
                <div class="row">
                  <div class="col-md-12">
                    <div class="product-section-pl-header">
                      <div class="product-section-pl-hd-flex">
                        <h3>10k Oil Change Service Synthetic (10W40) </h3>

                        <div class="lbl-flex">
                          <label>
                            <span class="rec-lab">
                              Recommended{" "}
                              <i class="fa-regular fa-thumbs-up"></i>
                            </span>
                            <span class="free-lab">Free Regular Service</span>
                          </label>

                          <label class="chk-label mob-compare">
                            Compare
                            <input type="checkbox" />
                            <span class="check-mark"></span>
                          </label>
                        </div>
                      </div>

                      <div class="mnf-yrs">Year of Manufacture 2019</div>
                    </div>
                  </div>

                  <div class="pl-fl-box">
                    <div class="pl-fl-img">
                      <div class="position-relative-pr">
                        <img
                          class="product-image-container-pl"
                          src="/assets/products/oil-change-10k-oil-change-service-full-synthetic-5w40.webp"
                        />
                      </div>
                    </div>

                    <div class="pl-fl-ft-sec">
                      <div class="pl-fl-lst min-pl-height">
                        <ul>
                          <li>
                            {" "}
                            <i>
                              {" "}
                              <img src="/assets/products/tick.webp" />
                            </i>{" "}
                            10000Km Oil And Filter change
                          </li>

                          <li>
                            {" "}
                            <i>
                              {" "}
                              <img src="/assets/products/tick.webp" />
                            </i>
                            10W40 Semi-Synthetic Engine Oil{" "}
                          </li>

                          <li>
                            {" "}
                            <i>
                              {" "}
                              <img src="/assets/products/tick.webp" />
                            </i>
                            Genuine Oil Filter
                          </li>
                          <li>
                            {" "}
                            <i>
                              {" "}
                              <img src="/assets/products/tick.webp" />
                            </i>
                            Fluid Top-up
                          </li>
                        </ul>

                        <label>+ View More</label>
                      </div>

                      <div class="pl-feture-first dsk-view">
                        <div class="oft-lbs">
                          <label
                            class="pl-offer-label"
                            data-toggle="modal"
                            data-target=".offer-modal-sm"
                          >
                            <img src="/assets/products/party-icon.webp" />3 Offer
                            Available
                          </label>
                          <label class="pl--tl-workshop">
                            {/* <i class="fa-solid fa-shop"></i>  */}
                            <img
                              width={15}
                              height={13}
                              style={{ marginBottom: "2px" }}
                              src="/assets/header/ob-network-new-logo.svg"
                              alt="Image"
                            />
                            12 Workshops
                          </label>
                        </div>

                        <label class="chk-label">
                          Add to Compare
                          <input
                            type="checkbox"
                            onChange={(e) => handleCompare(e, index)}
                          />
                          <span class="check-mark"></span>
                        </label>
                      </div>

                      <div class="price-pl-blck dsk-view">
                        <div class="price-pl-lf">
                          <label class="price-tag-pl">
                            <span>Best Price</span>
                            <strong>AED 369.00</strong>
                          </label>
                        </div>
                        <div class="price-pl-rght">
                          <div class="fitting-checkbox">
                            <label class="chk-label">
                              Get Fitting at Home
                              <input type="checkbox" />
                              <span class="check-mark"></span>
                            </label>
                            <small>AED 100.00 Extra Charge</small>
                          </div>
                          <button class="srv-act-action">Select</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mobile-pl-bar-action">
                    <div class="pl-feture-first">
                      <div class="price-pl-lf">
                        <label class="price-tag-pl">
                          <span>Best Price</span>
                          <strong>AED 369.00</strong>
                        </label>
                      </div>

                      <div class="oft-lbs">
                        <label class="pl-offer-label">
                          <img src="/assets/products/party-icon.webp" />3 Offer
                          Available
                        </label>
                        <label class="pl--tl-workshop">
                          {/* <i class="fa-solid fa-shop"></i> */}
                          <img
                            width={15}
                            height={13}
                            style={{ marginBottom: "2px" }}
                            src="/assets/header/ob-network-new-logo.svg"
                            alt="Image"
                          />
                          12 Workshops
                        </label>
                      </div>
                    </div>

                    <div class="mobile-bottom-sr-select">
                      <div class="fitting-checkbox">
                        <label class="chk-label">
                          Get Fitting at Home
                          <input type="checkbox" />
                          <span class="check-mark"></span>
                        </label>
                        <small>AED 100.00 Extra Charge</small>
                      </div>

                      <button class="srv-act-action">Select</button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div class="tyre-fet-usr d-none">
        <h3>Why Buy Your Car Tyres With Open Bonnet?</h3>
        <ul>
          <li>
            <img src="/assets/products/thumb.svg" />
            <span>Best Prices</span>
          </li>
          <li>
            <img src="/assets/products/thumb.svg" />
            <span>Widest Outlet Network</span>
          </li>
          <li>
            <img src="/assets/products/thumb.svg" />
            <span>Split In Installments</span>
          </li>
          <li>
            <img src="/assets/products/thumb.svg" />
            <span> No Hidden Charges</span>
          </li>
          <li>
            <img src="/assets/products/thumb.svg" />
            <span> Free 10K Rotation</span>
          </li>
        </ul>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddToCompare: (data) => {
      dispatch(AddToCompare(data));
    },
    RemoveFromCompare: (data) => {
      dispatch(RemoveFromCompare(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TyresListing);
